import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { Promo } from 'src/app/assabil-sales/models/entities/promo-entity';
import { PromoPipe } from 'src/app/assabil-sales/pipes/promo-pipe';
import { PromoService } from 'src/app/assabil-sales/services/pomo-service';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { DateRangePipe } from 'src/app/tools/pipes/date-range-pipe';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';

@Component({
  selector: 'promo-list',
  templateUrl: './promo-list.component.html',
  styleUrls: ['./promo-list.component.scss']
})

export class PromoListComponent extends BasePage2<Promo> {

  // Filter fields
  // ---------------------------------------------------
  promoCode          : string;
  name               : string;
  promoTypeCode      : string;
  progressLevel      : number;
  startDate          : Date = null;
  endDate            : Date = null;
  // ---------------------------------------------------


  promoTypes              : any[];
  promos                  : Array<Promo> = [];
  promoPipe               : PromoPipe = new PromoPipe();

  constructor(
    private promoService      : PromoService,
    protected toastr          : ToastrService,
    protected dateRangePipe   : DateRangePipe,
    protected router          : Router,
    protected baseService     : BaseService,
    protected leanUtilsService: LeanUtilsService,
    protected location        : Location) {
      super(toastr, router, baseService, leanUtilsService, location);

      this.entityName = 'promo';
  }

  formFields = [];
  listFields = [
    { prop: 'promoCode',       name: 'Code',               style: {'font-weight': 'bold', 'font-style': 'italic'}},
    { prop: 'name',            name: 'Nom'                                                                       },
    { prop: 'progressLevel',   name: 'Niv. Progression ',  pipe : this.promoPipe                                 }, 
    { prop: 'promo',           name: 'Dates',              pipe : this.dateRangePipe                             },
  //{ prop: 'status',          name: 'Satut ',             pipe : this.promoPipe                                 }, 
    { prop: 'basedOnBurned',   name: 'Basé/Brulé',        type : 'boolean'                                       }, 
    { prop: 'burningPromo',    name: 'Brulante',          type : 'boolean'                                       }, 
    { prop: 'sequence',        name: 'Sequence',                                                                 }, 
    { prop: 'skipToSequence',  name: 'Aller à',            pipe : this.promoPipe                                 }, 
  ]

  initEntityContainer() {
  }

  newPromo() {
    let promo  = new Promo();
    let now = new Date();
    promo.promoCode       =  "" + now.getTime(); //now.getFullYear() + '-' + (now.getMonth()+1) + '-' + now.getDate();
    promo.skipToSequence  = 0;

    promo.sequence        = 0;
    promo.scaleMethod     = 2;
    promo.breakPointType  = 1;

    promo.edit     = true; 
    promo.inserted = true; 
    promo.edit     = true; 
    this.selectedRow = promo;
  }

  getRows(): Promo[] {
      return this.promos;
  }

  saveRow(row: Promo): Promise<Promo> {
      return this.promoService.promoSave(row);
  }


  progressLevelPipe(promo : Promo){
    let promoPipe : PromoPipe = new PromoPipe();
    return promoPipe.transform(promo, 'progressLevel');
  }

  statusPipe(promo : Promo){
    let promoPipe : PromoPipe = new PromoPipe();
    return promoPipe.transform(promo, 'status');
  }

  initParams(){
    this.promoService.promoTypesGet().then(promoTypes => {
      this.promoTypes = promoTypes;
    });
  }



  loadData(){
    this.promoService.promosGet(this.promoCode, this.name, this.progressLevel, this.startDate, this.endDate).then(promos => {
      this.promos = promos;
  //    for (let i=0; i<this.promos.length; i++){
  //      this.promos[i].promo = this.promos[i];
  //    }
    });
  }


/*
  onSelect(event: any) {
    let tmp : Promo = event.selected[0];
    this.promoService.promoDetailGet(tmp.promoCode).then(promo => {
      let index           = this.promos.indexOf(tmp);
      this.promos[index]  = promo;
      this.selectedRow    = promo;
    });    
  }
  */

  selectRow(promo : Promo){
    let index : number = this.promos.indexOf(promo);
    this.promoService.promoDetailGet(promo.promoCode).then(result => {
      this.promos[index] = result;
      this.selectedRow = result; 
      })
    .catch(error => {
      this.showError(error);
     })
  }

  getEntytiesList(){
    return this.promos;
  }

}

